module.exports = {"MOBILE_VIEW":false,"SPECIAL_COLOR":"#01B3C8","DEFAULT_STATUSES_TO_SHOW":[{"id":"520","name":"Müşteri Teslimatına Hazır","count":0},{"id":"550","name":"Teslim Edildi","count":0}],"DEFAULT_ACTIVE_STATUS":33,"COLLECTING_ACTIVE_STATUS":33,"PACKAGING_ACTIVE_STATUS":34,"DISTRIBUTION_ACTIVE_STATUS":37,"PRINT_CLICK_AND_COLLECT_ORDER_LIST":false}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/clickAndCollectOrderList.json
// module id = 1370
// module chunks = 1